<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height"
        >
            <v-col class="fill-height of-y" cols="3">
                <multi-select-list
                        :items="varieties"
                        itemKey="id"
                        :showCheckBoxes="true"
                        :multiple="false"
                        headlineKey="description"
                        sub-line-key="farmDescription"
                        v-model="selectedVarietyID"
                        filterLabel="Filter Varieties"
                >
                    <div slot="header" class="px-2 pt-2">
                        <v-btn
                                small
                                block
                                color="primary"
                                @click="createVarietyShow = !createVarietyShow"
                        >
                            <v-icon left>mdi-food-apple</v-icon>
                            Add Variety
                        </v-btn>
                    </div>
                </multi-select-list>
            </v-col>
            <divider color="primary darken-1" :vertical="true"/>
            <v-col class="fill-height of-y pa-2" cols="4" v-if="!!selectedVariety">
                <v-card>
                    <ModifyVariety :edit-variety="selectedVariety" @save="upsertVariety($event)"/>
                </v-card>
            </v-col>
            <v-dialog
                    v-if="createVarietyShow"
                    v-model="createVarietyShow"
                    :width="400"
                    persistent
            >
                <v-card>
                    <ModifyVariety :edit-variety="createVarietyObj" @dismiss="createVarietyShow = !createVarietyShow" @save="upsertVariety($event)"/>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyVariety from "./ModifyVarieties";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";

export default {
    components: {
        Divider,
        ModifyVariety,
        MultiSelectList
    },
    props: {},
    data() {
        return {
            selectedVarietyID: null,
            createVarietyObj: null,
            createVarietyShow: false,
        }
    },
    watch: {
        createVarietyShow(val) {
            if (val)
                this.createVarietyObj = {
                    id: null,
                    description: null
                }
        }
    },
    methods: {

        async upsertVariety(event) {
            console.log(event)
            let {variety, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/variety`, variety)
                const addedVarietyID = (await waitForEvent(eventID)).varieties.pop().id
                this.createVarietyShow = false
                this.selectedVarietyID = addedVarietyID;
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false
            }
        }

    },
    computed: {
        ...mapGetters(['varieties', 'farms']),
        selectedVariety() {
            if (!this.selectedVarietyID)
                return null
            return this.varieties.filter(obj => obj.id === this.selectedVarietyID).pop()
        },
    },
}
</script>

<style scoped>

</style>